"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.List = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Spinner_1 = require("@skbkontur/react-ui/components/Spinner");

var LayoutEvents_1 = require("@skbkontur/react-ui/lib/LayoutEvents");

var Log_1 = require("@skbkontur/plugin-js/lib/common/Log");

var Certificate_1 = require("../../Certificate");

var List_module_css_1 = tslib_1.__importDefault(require("./List.module.css"));

var constants_1 = require("../../../utils/constants");

var react_infinite_scroller_1 = tslib_1.__importDefault(require("react-infinite-scroller"));

var configuration_1 = require("../../../contexts/configuration");

var List =
/** @class */
function (_super) {
  tslib_1.__extends(List, _super);

  function List(props, context) {
    var _this = _super.call(this, props) || this;

    _this.log = Log_1.LogManager.getLog(constants_1.LOG_PREFIX + "List");

    _this.loadMore = function () {
      _this.refreshLayout();

      setTimeout(function () {
        var _a = _this.state,
            visibleItems = _a.visibleItems,
            page = _a.page;
        var items = _this.props.items;
        var nextPage = page + 1;
        var newVisibleItems = visibleItems.concat(_this.getPageItems(items, nextPage));

        _this.log.info('loadMore: nextPage=', nextPage);

        _this.context.trackEvent('loadMore', nextPage.toString());

        _this.setState({
          visibleItems: newVisibleItems,
          page: nextPage,
          hasMore: newVisibleItems.length < items.length
        }, function () {
          _this.refreshLayout();
        });
      }, 500);
    };

    _this.refreshLayout = function () {
      return LayoutEvents_1.emit();
    };

    _this.getPageItems = function (items, page) {
      var pageSize = _this.props.pageSize;
      var from = page * pageSize;
      var to = from + pageSize;
      return items.slice(from, to);
    };

    _this.keyPressHandler = function (e) {
      var _a = _this.state,
          selectedIndex = _a.selectedIndex,
          visibleItems = _a.visibleItems;
      var onEnter = _this.context.onEnter;

      if (onEnter && e.keyCode === constants_1.KEY_CODES.ENTER) {
        if (selectedIndex !== -1) {
          var selectedItem = visibleItems[selectedIndex];

          _this.context.trackEvent('keyPress', 'onEnterForSelected');

          onEnter(selectedItem.certificate, selectedItem.storeInfo, selectedItem);
        } else if (visibleItems.length === 1) {
          var selectedItem = visibleItems[0];

          _this.context.trackEvent('keyPress', 'onEnterForSingle');

          onEnter(selectedItem.certificate, selectedItem.storeInfo, selectedItem);
        }
      } else if (visibleItems.length) {
        _this.moveSelection(e);
      }
    };

    _this.onBlur = function (e) {
      _this.setState({
        selectedIndex: -1
      });
    };

    _this.moveSelection = function (e) {
      var _a = _this.state,
          selectedIndex = _a.selectedIndex,
          visibleItems = _a.visibleItems;
      var newIndex;

      switch (e.keyCode) {
        case constants_1.KEY_CODES.UP:
          {
            _this.context.trackEvent('keyPress', 'up');

            newIndex = selectedIndex === -1 || selectedIndex === 0 ? visibleItems.length - 1 : selectedIndex - 1;
            break;
          }

        case constants_1.KEY_CODES.DOWN:
          {
            _this.context.trackEvent('keyPress', 'down');

            newIndex = selectedIndex === -1 || selectedIndex === visibleItems.length - 1 ? newIndex = 0 : selectedIndex + 1;
            break;
          }
      }

      if (newIndex !== undefined) {
        e.preventDefault();

        _this.setState({
          selectedIndex: newIndex
        });
      }
    };

    var page = 0;

    var visibleItems = _this.getPageItems(props.items, page);

    _this.state = {
      selectedIndex: -1,
      visibleItems: visibleItems,
      page: page,
      hasMore: visibleItems.length < props.items.length
    };

    if (context.selectable) {
      window.addEventListener('keydown', _this.keyPressHandler);
    }

    return _this;
  }

  List.prototype.componentWillUnmount = function () {
    if (this.context.selectable) {
      window.removeEventListener('keydown', this.keyPressHandler);
    }
  };

  List.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
    var _this = this;

    var items = nextProps.items;

    if (items.length === this.props.items.length) {
      // копируем видимые элементы, и обновляем их
      var newVisibleItems = items.slice(0, this.state.visibleItems.length);
      this.setState({
        visibleItems: newVisibleItems
      });
    } else {
      // сбрасываем на первую страницу.
      var page = 0;
      var visibleItems = this.getPageItems(items, page);
      this.setState({
        selectedIndex: -1,
        visibleItems: visibleItems,
        page: page,
        hasMore: visibleItems.length < items.length
      }, function () {
        _this.refreshLayout();
      });
    }
  };

  List.prototype.componentDidMount = function () {// console.timeEnd('P_Render');
    // @ts-ignore
    // console.log('P_Render2: ', Date.now() - window.renderStart);
    // console.timeEnd('P_All');
  };

  List.prototype.render = function () {
    var _this = this;

    var items = this.props.items;
    var _a = this.context,
        onClick = _a.onClick,
        onDoubleClick = _a.onDoubleClick;
    var _b = this.state,
        visibleItems = _b.visibleItems,
        hasMore = _b.hasMore;
    var selectedIndex = this.state.selectedIndex;
    var certificates = visibleItems.map(function (item, index) {
      var onFocus = function onFocus(e) {
        if (/Kebab/.test(e.target.className)) {
          return;
        }

        if (index !== _this.state.selectedIndex) {
          _this.setState({
            selectedIndex: index
          });
        }
      };

      return react_1.default.createElement("div", {
        key: item.certificate.thumbprint(),
        tabIndex: 0,
        onFocus: onFocus,
        className: List_module_css_1.default.item
      }, react_1.default.createElement(Certificate_1.Certificate, {
        index: index,
        item: item,
        first: index === 0,
        last: index === visibleItems.length - 1,
        onClick: onClick,
        onDoubleClick: onDoubleClick,
        selected: selectedIndex === index
      }));
    });
    this.log.info('visibleCount', visibleItems.length, 'fullCount', items.length);
    var loader = react_1.default.createElement("div", {
      className: List_module_css_1.default.loader
    }, react_1.default.createElement(Spinner_1.Spinner, {
      type: "mini"
    }));
    return react_1.default.createElement("div", {
      onBlur: this.onBlur
    }, react_1.default.createElement(react_infinite_scroller_1.default, tslib_1.__assign({
      loadMore: this.loadMore,
      hasMore: hasMore,
      loader: loader,
      useWindow: !this.context.modalOptions
    }, this.context.modalOptions ? {
      getScrollParent: function getScrollParent() {
        return document.querySelector('[data-tid="modal-container"]');
      }
    } : {}), certificates));
  };

  List.contextType = configuration_1.configurationContext;
  return List;
}(react_1.default.Component);

exports.List = List;